import classNames from "classnames";

const Colours: Record<string, string> = {
  warning: "text-secondary bg-warning",
  info: "text-body bg-info",
  light: "text-white bg-info-strong",
};

/** A page-builder badge's classes for a Bootstrap colour name, e.g. "success". */
export function badgeClassName(variant: string | undefined) {
  const name = variant || "secondary";

  return classNames("badge", Colours[name] ?? `text-white bg-${name}`);
}
